import {Component, OnInit} from '@angular/core';
import {Admin} from "../admin";
import {AuthService} from "../auth.service";
import {Router} from "@angular/router";
import {QuestionVersion} from "../question-version";
import {QuestionService} from "../question.service";
import {Question} from "../question";

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  public admin: Admin;
  public newAdminUserName: string;
  public newAdminPassword: string;

  public questionVersion: QuestionVersion = null;
  public versionLabel : string ="";

  constructor(private authService: AuthService,
              private router: Router,
              private questionService: QuestionService) {
    this.authService.currentAdmin$.subscribe(
      (newAdmin : Admin) => {
        this.admin = newAdmin;
      }
    );
    this.questionService.questionVersion$.subscribe(
      (newVersion : QuestionVersion) => {
        //console.log("newVersion",newVersion);
        if(newVersion != null){
          this.questionVersion = newVersion;
          this.versionLabel = newVersion.versionLabel;
        }
      }
    );
    this.questionService.loadQuestionList();
  }

  ngOnInit() {
  }

  public saveVersion() {
    this.questionVersion.versionLabel = this.versionLabel;
    this.questionService.saveVersion(this.questionVersion).subscribe(
      (res) => {
        alert("Kysymysten versionumero päivitetty! " + this.versionLabel);
      },
      err => {
        alert("Kysymysten versionumero päivitys epäonnistui!");
        console.error(err);
      });
  }

  save(admin: Admin) {
    this.authService.saveAdmin(admin).subscribe(res => {
      this.router.navigate(['/welcome']);
    });
  }

  cancel() {
    this.authService.update();
    this.router.navigate(['/welcome']);
  }

  createNewAccount() {
    if (this.newAdminUserName.length < 4 || this.newAdminPassword.length < 4) {
      alert("Käyttäjänimi tai salasana liian lyhyt!");
      return;
    }

    this.authService.createAdmin(this.newAdminUserName, this.newAdminPassword).subscribe(
      res => {
        if (res) {
          alert("Uusi käyttäjä luotu:\nNimi: " + this.newAdminUserName + "\nSalasana: " + this.newAdminPassword);
        }
      },
      err => {
        alert("Uuden käyttäjän luonti epäonnistui!");
        console.error(err);
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/settings.component.ts